import React, { useEffect, useState, useRef, useMemo } from "react";
import {
  AddCircleOutline,
  Delete,
  Edit,
  Group,
  VerifiedUser,
  PersonRemove,
  PersonAdd,
  ExpandMore,
  Visibility
} from "@mui/icons-material";
import { Button, IconButton, Switch } from "@mui/material";
import { Row, Col, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import MasterViewController from "../../redux/actions/masterApiActions";
import AddEmployeeModal from "./AddEmployeeForm";
import "../../styles/styles.css";
import "../../styles/layout.css";
import ReusableGrid from "../../components/ag grid/ReusableGrid";
import DeleteIcon from "@mui/icons-material/Delete";
import { Tooltip } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import ExportButton from "../../components/ag grid/ExportButton";
import PageSizeSelector from "../../components/ag grid/PageSizeSelector";
import EmployeeProfileView from "./ViewEmployee";
import EmployeeProfileVeiwController from "../../redux/actions/EmployeeProfileApiAction";
import FilterListIcon from '@mui/icons-material/FilterList';
import usePermission from "../../utils/usePermission";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { getUserInfoFromToken } from "../../utils/authUtils";
import FilterEmployeeDrawer from "./FilterEmployee";

const UserListPage = () => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);

  const [showModal, setShowModal] = useState(false);
  const [editEmployee, setEditEmployee] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [open, setOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const { getEmployees, deleteEmployee,updateEmployee,addBulkEmployeeData } = EmployeeProfileVeiwController();
  const { employee_data } = useSelector((state) => state.employeeProfile);
  const employees = employee_data?.employees || [];
  // const userType = localStorage.getItem("user_type");
  const [userType, setUserType] = useState(null);
  const [userId, setUserId] = useState(null);
  const { hasPermission } = usePermission();
  const [filterOpen, setFilterOpen] = useState(false);

  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  // const [finalEmployees, setFinalEmployees] = useState(employees);
  // const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  // const numberOfTables = 0; // change this to however many tables you need
  // const tableHeight = screenHeight / numberOfTables;

  // useEffect(() => {
  //   const handleResize = () => setScreenHeight(window.innerHeight);
  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);
  

  useEffect(() => {
    dispatch(getEmployees());
  }, []);
  useEffect(() => {
  if (employees.length > 0) {
    setFilteredEmployees(employees);  // default = all employees
  }
}, [employees]);

  const formikRef = useRef();
            useEffect(() => {
            const { userType, userId } = getUserInfoFromToken();
            setUserType(userType);
            setUserId(userId);
          }, []);
  
  const handleDelete = (employeeId) => {
    dispatch(deleteEmployee(employeeId.id));
  };

  const handleEdit = (employee) => {
    setEditEmployee(employee);
    setOpen(true);
  };
  
  const handleView = (employee) => {
    setSelectedEmployee(employee);
    setShowViewModal(true);
  };
  const openModalForCreate = () => {
        setEditEmployee(null);
        setOpen(true);
  };
  const finalEmployees = useMemo(() => {
  let data = filteredEmployees;

  // Apply search on filteredEmployees
  if (searchTerm) {
    const lowercasedValue = searchTerm.toLowerCase();
    data = data.filter(emp =>
      emp.first_name?.toLowerCase().includes(lowercasedValue) ||
      emp.last_name?.toLowerCase().includes(lowercasedValue) ||
      emp.email?.toLowerCase().includes(lowercasedValue) ||
      emp.mobile_number?.toLowerCase().includes(lowercasedValue) ||
      emp.employee_id?.toLowerCase().includes(lowercasedValue) 
      // emp?.profile_data?.designation_name?.toLowerCase().includes(lowercasedValue) ||
      // emp?.profile_data?.department_name?.toLowerCase().includes(lowercasedValue)
    );
  }

  return data;
}, [filteredEmployees, searchTerm]);

const handleFilterApply = (filtered) => {
  setFilteredEmployees(filtered); 
  // filtered could be [] (no match) or [..] (match)
};
// useEffect(() => {
//   setFilteredEmployees(employees);
//   setFinalEmployees(employees);
// }, [employees]);

// // Handle search (apply on filteredEmployees instead of employees)
// useEffect(() => {
//   if (!searchTerm) {
//     setFinalEmployees(filteredEmployees);
//   } else {
//     const lowercasedValue = searchTerm.toLowerCase();
//     const searched = filteredEmployees.filter((emp) =>
//       emp.first_name?.toLowerCase().includes(lowercasedValue) ||
//       emp.last_name?.toLowerCase().includes(lowercasedValue) ||
//       emp.email?.toLowerCase().includes(lowercasedValue) ||
//       emp.mobile_number?.toLowerCase().includes(lowercasedValue) ||
//       emp.employee_id?.toLowerCase().includes(lowercasedValue) ||
//       emp?.profile_data?.designation_name?.toLowerCase().includes(lowercasedValue) ||
//       emp?.profile_data?.department_name?.toLowerCase().includes(lowercasedValue)
//     );
//     setFinalEmployees(searched);
//   }
// }, [searchTerm, filteredEmployees]);

// // When filter is applied from Drawer
// const handleFilterApply = (filtered) => {
//   setFilteredEmployees(filtered);
//   setSearchTerm(""); // reset search when new filter is applied (optional)
// };


  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      maxWidth: 50,
      pinned: "left",
      colId: "checkboxColumn",
      flex: 1
    },
    {
      headerName: "Emp ID",
      field: "employee_id",
      flex: 1,
      maxWidth: 80,
      pinned: "left"
    },
    {
      headerName: "Name",
      valueGetter: (params) =>
        `${params.data.first_name} ${params.data.last_name}`,
      flex: 1
    },
    { headerName: "Email", field: "email", flex: 1 },
    { headerName: "Phone", field: "mobile_number", flex: 1 },
    { headerName: "Department", field: "profile_data.department_name", flex: 1 },
    userType === "Admin"
      ? { headerName: "Company Name", field: "company.company_name", flex: 1 }
      : { headerName: "Designation", field: "profile_data.designation_name", flex: 1 },
    { headerName: "Joining Date", field: "profile_data.joining_date", flex: 1 },
    {
  headerName: "Active",
  field: "is_active",
  flex: 0.5,
  cellRenderer: (params) => {
    const handleChange = (e) => {
  const updatedValue = e.target.checked;

  // Update UI instantly
  params.node.setDataValue("is_active", updatedValue);

  // Only send the is_active field (avoid sending full employee object)
  const updatedData = {
     is_active: updatedValue,
    email: params.data.email,
    mobile_number: params.data.mobile_number
  };

  // Dispatch update API call
  dispatch(updateEmployee(params.data.id, updatedData))
    .then(() => {
      console.log("Employee active status updated");
    })
    .catch((err) => {
      console.error("Failed to update active status", err);
    });
};

    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Switch
          checked={params.value}
          onChange={handleChange}
          color="primary"
          size="small"
        />
      </div>
    );
  }
},
    {
      headerName: "Actions",
      field: "actions",
      minWidth: 160,
      maxWidth: 180,
      suppressSizeToFit: true,
      pinned: "right",
      headerClass: "ag-header-center",
      cellStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "visible"
      },
      cellRenderer: (params) => (
        <div style={{ display: "flex", gap: "6px", justifyContent: "center" }}>
          <Tooltip title="View">
            <IconButton
              color="primary"
              size="small"
              onClick={() => handleView(params.data)}
            >
              <VisibilityIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          {(userType === "Admin" || hasPermission("employee_list", "edit"))&&(
          <Tooltip title="Edit">
            <IconButton
              sx={{ color: "#808080" }}
              size="small"
              onClick={() => handleEdit(params.data)}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          )}
          {(userType === "Admin" || hasPermission("employee_list", "delete")) && (
          <Tooltip title="Delete">
            <IconButton
              sx={{ color: "#d32f2f" }}
              size="small"
              onClick={() => handleDelete(params.data)}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          )}
        </div>
      )
    }
  ];

  return (
    <div>
      <div  className="d-flex align-items-center flex-wrap  mb-3" style={{ justifyContent: "space-between",gap: "12px" }}>
        <div className="d-flex align-items-center" style={{ gap: "12px" }}>
  {( userType === "Admin" || hasPermission("employee_list", "create")) && (
    <Button
      variant="contained"
      startIcon={<AddCircleOutline />}
      onClick={openModalForCreate}
      sx={{
        borderRadius: "8px",
        backgroundColor: "#1976d2",
        textTransform: "none",
        paddingX: 2,
        height: "40px",
        fontSize: "0.875rem",
      }}
    >
      Add Employee
    </Button>
  )}
  
  {selectedRows.length > 0 ? (
      // Show Export button when rows are selected
      (userType === "Admin" || hasPermission("employee_list", "export")) && (
        <ExportButton
          gridRef={gridRef}
          fileName="EmployeeList.xlsx"
          exportColumns={[
            "employee_id",
            "first_name",
            "last_name",
            "email",
            "mobile_number",
            "department",
            "designation",
            "joining_date",
            "is_active",
          ]}
        />
      )
    ) : (
      // Show Import button when no rows are selected
      (userType === "Admin" || hasPermission("employee_list", "import")) && (
        <Button
          variant="contained"
          startIcon={<UploadFileIcon />} // MUI icon for file upload
          component="label"
          sx={{
            borderRadius: "8px",
            textTransform: "none",
            paddingX: 2,
            height: "40px",
            fontSize: "0.875rem",
          }}
        >
          Import
          <input
      type="file"
      hidden
      accept=".xlsx,.xls"
      onChange={(e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
          console.log("Selected file:", selectedFile); // ✅ Debug check
          dispatch(addBulkEmployeeData(selectedFile));
        }
        e.target.value = ""; // reset so selecting same file again triggers change
      }}
    />
        </Button>
      )
    )}

  </div>

  {/* Search bar taking max width */}
  <div style={{ flexGrow: 1, minWidth: "200px" }}>
   <Form.Control
            type="text"
            placeholder="Search employees..."
            style={{ height: "40px" }}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
  </div>

  {/* Filter icon */}
  <Tooltip title="Filter">
  <IconButton
    size="small"
    sx={{ border: "1px solid #ccc" }}
    onClick={(e) => setFilterAnchorEl(e.currentTarget)}   // ✅ set anchor element
  >
    <FilterListIcon />
  </IconButton>
</Tooltip>


  {/* Page size selector */}
  <PageSizeSelector
    pageSize={pageSize}
    onChange={(e) => setPageSize(Number(e.target.value))}
  />
</div>
      <Row className="mt-2 g-3">
        <Col xs={12} sm={6} md={3}>
          <div className="card d-flex flex-row align-items-center p-2">
            <div className="avatar rounded-circle bg-primary">
              <Group className="white-icon" />
            </div>
            <div className="ms-2">
              <h6 className="fs-13 fw-medium text-default mb-1">
                Total Employee
              </h6>
              <h3 className="value m-0">
                {employee_data?.total_employees || 0}
              </h3>
            </div>
          </div>
        </Col>
        <Col xs={12} sm={6} md={3}>
          <div className="card d-flex flex-row align-items-center p-2">
            <div className="avatar rounded-circle bg-info">
              <VerifiedUser className="white-icon" />
            </div>
            <div className="ms-2">
              <h6 className="fs-13 fw-medium text-default mb-1">Active</h6>
              <h3 className="value m-0">
                {employee_data?.active_employees || 0}
              </h3>
            </div>
          </div>
        </Col>
        <Col xs={12} sm={6} md={3}>
          <div className="card d-flex flex-row align-items-center p-2">
            <div className="avatar rounded-circle bg-primary">
              <PersonRemove className="white-icon" />
            </div>
            <div className="ms-2">
              <h6 className="fs-13 fw-medium text-default mb-1">InActive</h6>
              <h3 className="value m-0">
                {employee_data?.inactive_employees || 0}
              </h3>
            </div>
          </div>
        </Col>
        <Col xs={12} sm={6} md={3}>
          <div className="card d-flex flex-row align-items-center p-2">
            <div className="avatar rounded-circle bg-danger">
              <PersonAdd className="white-icon" />
            </div>
            <div className="ms-2">
              <h6 className="fs-13 fw-medium text-default mb-1">New Joiners</h6>
              <h3 className="value m-0">
                {employee_data?.new_joiners_count || 0}
              </h3>
            </div>
          </div>
        </Col>
      </Row>

      <div className="ag-theme-material" style={{ height: "70vh" }}>
        <ReusableGrid
        rowData={finalEmployees}  
          columnDefs={columnDefs}
          gridRef={gridRef}
          pagination={true}
          pageSize={pageSize}
          onSelectionChanged={(rows) => setSelectedRows(rows)}
          // height={tableHeight}
        
        />
      </div>
      <AddEmployeeModal
        open={open}
        handleClose={() => setOpen(false)}
        initialData={editEmployee}
      />
      <EmployeeProfileView
        show={showViewModal}
        handleClose={() => setShowViewModal(false)}
        selectedEmployee={selectedEmployee}
      />
      {/* <AddEmployeeModal open={open} handleClose={() => setOpen(false)} /> */}
     <FilterEmployeeDrawer
  anchorEl={filterAnchorEl}
  handleClose={() => setFilterAnchorEl(null)}
  employees={employees}
  // onApply={(filtered) => setFilteredEmployees(filtered)}
  onApply={handleFilterApply}
/>

    </div>
  );
};

export default UserListPage;
